module.exports = __webpack_public_path__ + "ky.svg?18cdf70ca61438766035963454b590bf";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/ky.svg
// module id = 1299
// module chunks = 27